import React from 'react';
import {Box, Grid, Typography} from '@mui/material';

export interface SourceDestinationProps {
  source?: JSX.Element;
  destination?: JSX.Element;
  sourceLabel?: string;
  destinationLabel?: string;
  fromError: string | undefined;
  toError: string | undefined;
}

const SourceDestination = ({
  source,
  destination,
  sourceLabel = 'Source',
  destinationLabel = 'Destination',
  fromError: _fromError,
  toError: _toError,
}: SourceDestinationProps) => {
  const fromError = typeof _fromError === 'string' ? _fromError : undefined;
  const toError = typeof _toError === 'string' ? _toError : undefined;
  return (
    <Box pt={2} pb={2} height="100%" display="flex">
      <Grid container spacing={3} justifyContent="space-around" direction="row">
        {source && (
          <Grid
            data-test="Source Choices"
            item
            xs={destination ? 6 : 12}
            xl={destination ? 5.8 : 12}
          >
            <Typography variant="h4" color={fromError ? 'error' : 'primary'}>
              <strong>
                {sourceLabel}
                {fromError ? ' (required)' : ''}:
              </strong>
            </Typography>
            <Box mt={1} />
            {source}
          </Grid>
        )}
        {destination && (
          <Grid
            data-test="Destination Choices"
            item
            xs={source ? 6 : 12}
            xl={source ? 5.8 : 12}
          >
            <Typography variant="h4" color={toError ? 'error' : 'primary'}>
              <strong>
                {destinationLabel}
                {toError ? ' (required)' : ''}:
              </strong>
            </Typography>
            <Box mt={1} />
            {destination}
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default SourceDestination;
